/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Form, Modal, Table, Descriptions, Input, Tag, Grid } from "antd";
import axios from "axios";
import { useState, useEffect } from "react";

import ViewResponseModal from "./ViewResponseModal";
import { showErrorNotification, showSuccessNotification } from "../../../utils/notification";
import TextEditor from "../../common-utils/TextEditor";

export const REQUEST_TYPES = {
  CONTACT_US: "CONTACT_US",
  CALLBACK_REQUEST: "CALLBACK_REQUEST",
};

export const REPLY_TYPES = {
  EMAIL: "EMAIL",
  CALL_LOG: "CALL_LOG",
};

const ReplyUserQueryModal = ({
  isModalOpen = false,
  currentQueryId,
  setIsModalOpen = () => {},
  ROOT_URL = ""
}) => {
  const [form] = Form.useForm();
  const screens = Grid.useBreakpoint();
  const isMobileView = screens.md === false;

  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const [queryDetails, setQueryDetails] = useState({});
  const [currentResponse, setCurrentResponse] = useState("");
  const [currentResponseType, setCurrentResponseType] = useState(REPLY_TYPES.EMAIL);
  const [isViewResponseModalOpen, setIsViewResponseModalOpen] = useState(false);

  const isCallbackRequest = queryDetails.requestType === REQUEST_TYPES.CALLBACK_REQUEST;

  const sendReplyToUserQuery = (requestId, replyMessage, replyType = REPLY_TYPES.EMAIL) => {
    axios
      .post(`${ROOT_URL}/admin/user-queries/reply`, {
        requestId,
        message: replyMessage,
        replyType
      })
      .then(() => {
        showSuccessNotification("Replied Successfully");
        fetchQueryDetails();
        form.resetFields();
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const fetchQueryDetails = () => {
    axios
      .get(`${ROOT_URL}/admin/user-queries/query-details`, {
        params: {
          requestId: currentQueryId
        }
      })
      .then((res) => {
        const details = res.data;
        setQueryDetails(details);
      })
      .catch((err) => {
        showErrorNotification(err);
      });
  };

  const removePMargin = (str) => {
    return str?.replace(/<p>/g, "<p style='margin: 0px;'>");
  };

  const handleQueryResponse = (values) => {
    if (isCallbackRequest) {
      sendReplyToUserQuery(currentQueryId, values.callMessage, REPLY_TYPES.CALL_LOG);
    } else {
      sendReplyToUserQuery(currentQueryId, removePMargin(values.replyMessage), REPLY_TYPES.EMAIL);
    }
  };

  const responsesTableColumns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Responded By",
      dataIndex: "respondedBy",
      key: "respondedBy"
    },
    {
      title: "Type",
      dataIndex: "replyType",
      key: "replyType",
      render: (type) => {
        const isCall = type === REPLY_TYPES.CALL_LOG;
        return <Tag color={isCall ? "orange" : "blue"}>{isCall ? "CALL LOG" : "EMAIL"}</Tag>;
      }
    },
    {
      title: "Response Text",
      key: "responseHTML",
      render: (row) => (
        <Button
          type="primary"
          onClick={() => {
            setCurrentResponse(row.responseHTML);
            setCurrentResponseType(row.replyType);
            setIsViewResponseModalOpen(true);
          }}
        >
          {row.replyType === REPLY_TYPES.CALL_LOG ? "View Call Log" : "View Response"}
        </Button>
      )
    }
  ];

  useEffect(() => {
    fetchQueryDetails();
  }, []);

  return (
    <Modal
      title={isCallbackRequest ? "Log Callback Response" : "Reply"}
      open={isModalOpen}
      footer={[]}
      onOk={handleOk}
      onCancel={handleCancel}
      width="1500px"
    >
      <Table
        columns={responsesTableColumns}
        dataSource={queryDetails.responses || []}
        scroll={{ x: "max-content" }}
      />
      <Descriptions title="Details" bordered column={1}>
        <Descriptions.Item label="Title">{queryDetails.queryTitle}</Descriptions.Item>
        <Descriptions.Item label="Description">{queryDetails.queryDescription}</Descriptions.Item>
      </Descriptions>
      <br />
      <Form
        form={form}
        name="user_query_reply_form"
        layout={isMobileView ? "vertical" : "horizontal"}
        onFinish={handleQueryResponse}
      >
        {isCallbackRequest ? (
          <Form.Item
            name="callMessage"
            label="Call Summary / Conversation Notes"
            rules={[
              {
                required: true,
                message: "Please enter conversation details!"
              }
            ]}
          >
            <Input.TextArea rows={4} placeholder="Log the details of the phone call here..." />
          </Form.Item>
        ) : (
          <Form.Item
            name="replyMessage"
            label="Reply Message"
            rules={[
              {
                required: true,
                message: "Please enter a valid message!"
              }
            ]}
          >
            <TextEditor />
          </Form.Item>
        )}

        <Form.Item className="submit-btn">
          <Button type="primary" htmlType="submit">
            {isCallbackRequest ? "Save Call Log" : "Send Reply"}
          </Button>
        </Form.Item>
      </Form>
      {isViewResponseModalOpen && (
        <ViewResponseModal
          title={currentResponseType === REPLY_TYPES.CALL_LOG ? "View Call Log" : "View Response"}
          responseHtmlContent={currentResponse}
          isModalOpen={isViewResponseModalOpen}
          setIsModalOpen={setIsViewResponseModalOpen}
        />
      )}
    </Modal>
  );
};
export default ReplyUserQueryModal;
